import './PromoButton.scss';
import { observer } from "mobx-react";
import { promoStore } from "../../../../../platform/stores";
import promoIcon from '../../../../../assets/icons/promo-icon2.svg';

export const PromoButton = observer(() => {
  const { promoButtonIsVisible } = promoStore;

  return (
    <>
      {promoButtonIsVisible && (
        <div className="promo-button" onClick={() => promoStore.setPromoModalIsOpen(true)}>
          <img src={promoIcon} alt="Promo"/>
        </div>
      )}
    </>
  );
})